export const cleanPhoneNumber = (phoneNumber) => {
  phoneNumber = phoneNumber.toString();
  return phoneNumber.replace(/[^+\d]+/g, '');
};

export const splitName = (name) => {
  return name.trim().split(/\s(.*)/, 2);
};

export const normalizeAndSanitizeString = (
  stringToChange,
  separator = '',
  sanitizeOnly = false
) => {
  if (sanitizeOnly) {
    return stringToChange.replace(/[\W_]+/g, separator);
  }
  return stringToChange.replace(/[\W_]+/g, separator).toLowerCase();
};

export const currencyFormatter = (
  amount,
  local = 'en-US',
  currency = 'USD'
) => {
  try {
    amount = parseFloat(amount);
    if (amount % 1 === 0) {
      return new Intl.NumberFormat(local, { style: 'currency', currency })
        .format(amount)
        .replace(/\D00$/, '');
    }
    return new Intl.NumberFormat(local, { style: 'currency', currency }).format(
      amount
    );
  } catch (error) {
    return 0;
  }
};

export const phoneNumberFormatter = (str, separator = '-') => {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');

  //Check if the input is of correct length
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }

  return null;
};

export const stripHtml = (stringToStrip) => {
  if (
    !stringToStrip ||
    stringToStrip === undefined ||
    stringToStrip === '' ||
    stringToStrip === null
  )
    return stringToStrip;
  return stringToStrip.replace(/(<([^>]+)>)/gi, ' ');
};
